import { AmmunitionStockEventServiceBase } from './ammunition-stock-event.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, HateoasMultipleResponseObject, markAsBackgroundServiceCall, ReportRunService, ReportSpecificationService } from '@scisys-uim/uim-common';
import { AmmunitionStockEvent } from 'assets-model';

@Injectable({
  providedIn: 'root'
})
export class AmmunitionStockEventService extends AmmunitionStockEventServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any,
    reportRunService: ReportRunService,
    reportSpecificationService: ReportSpecificationService) {
    super(http, environment, reportRunService, reportSpecificationService);
  }

  public findEventsSinceLatestStocktake(ammunitionStockId: number): Observable<HateoasMultipleResponseObject<AmmunitionStockEvent>> {
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<AmmunitionStockEvent>>(this.serviceBaseUrl + '/findEventsSinceLatestStocktake/' + ammunitionStockId));
  }


  public exampleRangerAmmunitionIssueTemplateParameters(backgroundServiceCall: boolean = true): Observable<{
    [key: string]: string
  }> {
    return this.http.get<{ [key: string]: string }>(this.serviceBaseUrl + '/exampleRangerAmmunitionIssueTemplateParameters', {
      headers: backgroundServiceCall ? markAsBackgroundServiceCall() : null
    });
  }

  public resendAcknowledgeEmails(rangerId: number): Observable<void> {
    return this.http.post<void>(this.serviceBaseUrl + '/resendAcknowledgeEmails/' + rangerId, {});
  }

  public acknowledgeIssue(token: string): Observable<void> {
    return this.http.post<void>(this.serviceBaseUrl + '/acknowledgeIssue', token);
  }

  public acknowledgeReturn(token: string): Observable<void> {
    return this.http.post<void>(this.serviceBaseUrl + '/acknowledgeReturn', token);
  }

  public acknowledgeManual(ammunitionStockEventId: number): Observable<void> {
    return this.http.post<void>(this.serviceBaseUrl + '/acknowledgeManual/' + ammunitionStockEventId, {});
  }

}


